import React, { useEffect, useState } from "react";
import { Chart } from "primereact/chart";
import {
  getActiveUserSummary,
  getAverageTimeSpentSummary,
  getSignInDeviceSummary,
  getUserActionsSummary,
  getUserDashboard,
} from "../../../../services/user/userReportService";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SearchFiscalYear from "../../setup/finance/searchFiscalYear";
import { DialogActions, IconButton, Typography } from "@material-ui/core";
import { Search } from "@mui/icons-material";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { abbrMonthName, abbrNum, formatPercent } from "../../../../utils/utils";
import { DateTime } from "luxon";

function UserDashboard(props) {
  const { currentFiscalYear, currentFiscalPeriod, reload } = useGlobalData();
  const [
    openSearchFiscalYearActiveUser,
    setOpenSearchFiscalYearActiveUser,
  ] = useState(false);
  const [
    openSearchFiscalYearAverageTimeSpent,
    setOpenSearchFiscalYearAverageTimeSpent,
  ] = useState(false);
  const [
    openSearchFiscalYearUserActions,
    setOpenSearchFiscalYearUserActions,
  ] = useState(false);
  const [
    openSearchFiscalYearSignInDevice,
    setOpenSearchFiscalYearSignInDevice,
  ] = useState(false);
  const [openSearchFiscalYear, setOpenSearchFiscalYear] = useState(false);
  const [fiscalYearActiveUser, setFiscalYearActiveUser] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [fiscalYearAverageTimeSpent, setFiscalYearAverageTimeSpent] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [fiscalYearUserActions, setFiscalYearUserActions] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [fiscalYearSignInDevice, setFiscalYearSignInDevice] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalUsersPercent, setTotalUsersPercent] = useState(0);
  const [totalActiveUsers, setTotalActiveUsers] = useState(0);
  const [totalActiveUsersPercent, setTotalActiveUsersPercent] = useState(0);
  const [totalAverageTimeSpent, setTotalAverageTimeSpent] = useState(0);
  const [
    totalAverageTimeSpentPercent,
    setTotalAverageTimeSpentPercent,
  ] = useState(0);
  const [totalAverageSignIn, setTotalAverageSignIn] = useState(0);
  const [totalAverageSignInPercent, setTotalAverageSignInPercent] = useState(0);

  const [activeUserSummaryData, setActiveUserSummaryData] = useState({
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        type: "line",
        label: "Total Users",
        borderColor: "#12b18c",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        type: "bar",
        label: "Active Users",
        backgroundColor: "#0096ec",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        borderColor: "white",
        borderWidth: 2,
        borderRadius: 10,
      },
      {
        type: "bar",
        label: "Inactive Users",
        backgroundColor: "#fd7e14",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        borderColor: "white",
        borderWidth: 2,
        borderRadius: 10,
      },
    ],
  });

  const activeUserSummaryOptions = {
    maintainAspectRatio: false,
    aspectRatio: 1,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.dataset.label}: ${tooltipItem.formattedValue} Users`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#6c7293",
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  const [
    averageTimeSpentSummaryData,
    setAverageTimeSpentSummaryData,
  ] = useState({
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        type: "line",
        label: "User Time Spent",
        borderColor: "#12b18c",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
  });

  const averageTimeSpentSummaryOptions = {
    maintainAspectRatio: false,
    aspectRatio: 1,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.dataset.label}: ${tooltipItem.formattedValue} Minutes`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#6c7293",
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  const [topActiveUsersSummaryData, setTopActiveUsersSummaryData] = useState({
    labels: ["", "", "", "", ""],
    datasets: [
      {
        data: [0, 0, 0, 0, 0],
        backgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
        hoverBackgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
      },
    ],
  });

  const topActiveUsersSummaryOptions = {
    aspectRatio: 2.5,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "left",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.label}: ${tooltipItem.formattedValue} Minutes`;
          },
        },
      },
    },
  };

  const topActiveUsersSummaryPlugins = {
    id: "topActiveUsersSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (topActiveUsersSummaryData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const [
    lastLoginOverviewSummaryData,
    setLastLoginOverviewSummaryData,
  ] = useState({
    labels: [
      "Last Day",
      "Last Week",
      "Last 2 Weeks",
      "Last Month",
      "Never Signed In",
    ],
    datasets: [
      {
        data: [0, 0, 0, 0, 0],
        backgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
        hoverBackgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
      },
    ],
  });

  const lastLoginOverviewSummaryOptions = {
    aspectRatio: 2.5,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "left",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.label}: ${tooltipItem.formattedValue} Users`;
          },
        },
      },
    },
  };

  const lastLoginOverviewSummaryPlugins = {
    id: "lastLoginOverviewSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (lastLoginOverviewSummaryData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const [topVisitedAreasSummaryData, setTopVisitedAreasSummaryData] = useState({
    labels: ["", "", "", "", ""],
    datasets: [
      {
        data: [0, 0, 0, 0, 0],
        backgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
        hoverBackgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
      },
    ],
  });

  const topVisitedAreasSummaryOptions = {
    aspectRatio: 2.5,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "left",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.label}: ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
  };

  const topVisitedAreasSummaryPlugins = {
    id: "topVisitedAreasSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (topVisitedAreasSummaryData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const [userActionsSummaryData, setUserActionsSummaryData] = useState({
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        type: "line",
        label: "Create",
        borderColor: "#12b18c",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        type: "line",
        label: "Update",
        borderColor: "#0096ec",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        type: "line",
        label: "Delete",
        borderColor: "#f1416c",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        type: "line",
        label: "View",
        borderColor: "#6610f2",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
  });

  const userActionsSummaryOptions = {
    maintainAspectRatio: false,
    aspectRatio: 2.2,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.dataset.label}: ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#6c7293",
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  const [signInDeviceSummaryData, setSignInDeviceSummaryData] = useState({
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        type: "line",
        label: "Web Sign In",
        borderColor: "#12b18c",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        type: "line",
        label: "Mobile Sign In",
        borderColor: "#6610f2",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
  });

  const signInDeviceSummaryOptions = {
    maintainAspectRatio: false,
    aspectRatio: 2.2,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.dataset.label}: ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#6c7293",
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  async function getUserDashboardData(fiscalYearID = 0, fiscalPeriodID = 0) {
    const response = await getUserDashboard(fiscalYearID, fiscalPeriodID);
    const { data } = response.data;
    const {
      usersHeader,
      activeUsersHeader,
      averageTimeSpentHeader,
      averageSignInHeader,
      activeUserSummary,
      averageTimeSpentSummary,
      topActiveUsersSummary,
      lastLoginOverviewSummary,
      topVisitedAreasSummary,
      userActionsSummary,
      signInDeviceSummary,
    } = data;
    setTotalUsers(usersHeader.totalUsers);
    setTotalUsersPercent(usersHeader.totalUsersPercent);
    setTotalActiveUsers(activeUsersHeader.totalActiveUsers);
    setTotalActiveUsersPercent(activeUsersHeader.totalActiveUsersPercent);
    setTotalAverageTimeSpent(averageTimeSpentHeader.totalAverageTimeSpent);
    setTotalAverageTimeSpentPercent(
      averageTimeSpentHeader.totalAverageTimeSpentPercent
    );
    setTotalAverageSignIn(averageSignInHeader.totalAverageSignIn);
    setTotalAverageSignInPercent(averageSignInHeader.totalAverageSignInPercent);
    setActiveUserSummaryData(activeUserSummary.datasets);
    setAverageTimeSpentSummaryData(averageTimeSpentSummary.datasets);
    setTopActiveUsersSummaryData(topActiveUsersSummary.datasets);
    setLastLoginOverviewSummaryData(lastLoginOverviewSummary.datasets);
    setTopVisitedAreasSummaryData(topVisitedAreasSummary.datasets);
    setUserActionsSummaryData(userActionsSummary.datasets);
    setSignInDeviceSummaryData(signInDeviceSummary.datasets);
  }

  async function getActiveUserSummaryData(fiscalYearID = 0) {
    const response = await getActiveUserSummary(fiscalYearID);
    const { data } = response.data;
    setActiveUserSummaryData(data.activeUserSummary);
  }

  async function getAverageTimeSpentSummaryData(fiscalYearID = 0) {
    const response = await getAverageTimeSpentSummary(fiscalYearID);
    const { data } = response.data;
    setAverageTimeSpentSummaryData(data.averageTimeSpentSummary);
  }

  async function getUserActionsSummaryData(fiscalYearID = 0) {
    const response = await getUserActionsSummary(fiscalYearID);
    const { data } = response.data;
    setUserActionsSummaryData(data.userActionsSummary);
  }

  async function getSignInDeviceSummaryData(fiscalYearID = 0) {
    const response = await getSignInDeviceSummary(fiscalYearID);
    const { data } = response.data;
    setSignInDeviceSummaryData(data.signInDeviceSummary);
  }

  useEffect(() => {
    getUserDashboardData(currentFiscalYear.ID, currentFiscalPeriod.ID);
  }, [reload]);
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-3 col-md-3 col-lg-3 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="kt-widget4">
              <div className="kt-widget4__item">
                <span className="kt-widget4__icon kt-widget4__icon--2x">
                  <i className="fas fa-users" />
                </span>
                <div className="kt-widget4__info pr-0">
                  <div className="kt-widget4__title pr-0">
                    <Typography className="kt-font-bold text-muted">
                      Users
                    </Typography>
                  </div>
                  <div className="kt-widget4__value">
                    <Typography variant="h6" className="kt-font-bolder">
                      {abbrNum(totalUsers, 0)}
                    </Typography>
                  </div>
                  <div className="kt-widget4__forecast">
                    {totalUsersPercent === 0 ? (
                      <Typography className="kt-font-bold text-info">
                        <i className="fas fa-angle-double-right kt-font-info"></i>{" "}
                        {formatPercent(totalUsersPercent, 2, true)}
                      </Typography>
                    ) : totalUsersPercent > 0 ? (
                      <Typography className="kt-font-bold text-success">
                        <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                        {formatPercent(totalUsersPercent, 2, true)}
                      </Typography>
                    ) : totalUsersPercent < 0 ? (
                      <Typography className="kt-font-bold text-danger">
                        <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                        {formatPercent(totalUsersPercent, 2, true)}
                      </Typography>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="kt-widget4">
              <div className="kt-widget4__item">
                <span className="kt-widget4__icon kt-widget4__icon--2x">
                  <i className="fas fa-user-check" />
                </span>
                <div className="kt-widget4__info pr-0">
                  <div className="kt-widget4__title pr-0">
                    <Typography className="kt-font-bold text-muted">
                      Active Users
                    </Typography>
                  </div>
                  <div className="kt-widget4__value">
                    <Typography variant="h6" className="kt-font-bolder">
                      {abbrNum(totalActiveUsers, 0)}
                    </Typography>
                  </div>
                  <div className="kt-widget4__forecast">
                    {totalActiveUsersPercent === 0 ? (
                      <Typography className="kt-font-bold text-info">
                        <i className="fas fa-angle-double-right kt-font-info"></i>{" "}
                        {formatPercent(totalActiveUsersPercent, 2, true)}
                      </Typography>
                    ) : totalActiveUsersPercent > 0 ? (
                      <Typography className="kt-font-bold text-success">
                        <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                        {formatPercent(totalActiveUsersPercent, 2, true)}
                      </Typography>
                    ) : totalActiveUsersPercent < 0 ? (
                      <Typography className="kt-font-bold text-danger">
                        <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                        {formatPercent(totalActiveUsersPercent, 2, true)}
                      </Typography>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="kt-widget4">
              <div className="kt-widget4__item">
                <span className="kt-widget4__icon kt-widget4__icon--2x">
                  <i className="fas fa-user-clock" />
                </span>
                <div className="kt-widget4__info pr-0">
                  <div className="kt-widget4__title pr-0">
                    <Typography className="kt-font-bold text-muted">
                      Average Time Spent
                    </Typography>
                  </div>
                  <div className="kt-widget4__value">
                    <Typography variant="h6" className="kt-font-bolder">
                      {abbrNum(totalAverageTimeSpent, 0)} Minutes
                    </Typography>
                  </div>
                  <div className="kt-widget4__forecast">
                    {totalAverageTimeSpentPercent === 0 ? (
                      <Typography className="kt-font-bold text-info">
                        <i className="fas fa-angle-double-right kt-font-info"></i>{" "}
                        {formatPercent(totalAverageTimeSpentPercent, 2, true)}
                      </Typography>
                    ) : totalAverageTimeSpentPercent > 0 ? (
                      <Typography className="kt-font-bold text-success">
                        <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                        {formatPercent(totalAverageTimeSpentPercent, 2, true)}
                      </Typography>
                    ) : totalAverageTimeSpentPercent < 0 ? (
                      <Typography className="kt-font-bold text-danger">
                        <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                        {formatPercent(totalAverageTimeSpentPercent, 2, true)}
                      </Typography>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="kt-widget4">
              <div className="kt-widget4__item">
                <span className="kt-widget4__icon kt-widget4__icon--2x">
                  <i className="fas fa-sign-in-alt" />
                </span>
                <div className="kt-widget4__info pr-0">
                  <div className="kt-widget4__title pr-0">
                    <Typography className="kt-font-bold text-muted">
                      Average Sign In
                    </Typography>
                  </div>
                  <div className="kt-widget4__value">
                    <Typography variant="h6" className="kt-font-bolder">
                      {abbrNum(totalAverageSignIn, 0)} Times
                    </Typography>
                  </div>
                  <div className="kt-widget4__forecast">
                    {totalAverageSignInPercent === 0 ? (
                      <Typography className="kt-font-bold text-info">
                        <i className="fas fa-angle-double-right kt-font-info"></i>{" "}
                        {formatPercent(totalAverageSignInPercent, 2, true)}
                      </Typography>
                    ) : totalAverageSignInPercent > 0 ? (
                      <Typography className="kt-font-bold text-success">
                        <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                        {formatPercent(totalAverageSignInPercent, 2, true)}
                      </Typography>
                    ) : totalAverageSignInPercent < 0 ? (
                      <Typography className="kt-font-bold text-danger">
                        <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                        {formatPercent(totalAverageSignInPercent, 2, true)}
                      </Typography>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6 col-md-6 col-lg-6 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Users Overview
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(fiscalYearActiveUser.startMonthName) +
                            " " +
                            fiscalYearActiveUser.year +
                            " - " +
                            abbrMonthName(fiscalYearActiveUser.endMonthName) +
                            " " +
                            fiscalYearActiveUser.yearTo}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalYearActiveUser(true);
                              setOpenSearchFiscalYear(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="bar"
                  data={activeUserSummaryData}
                  options={activeUserSummaryOptions}
                  style={{ minHeight: "250px" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-6 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Average Users Time Spent
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(
                            fiscalYearAverageTimeSpent.startMonthName
                          ) +
                            " " +
                            fiscalYearAverageTimeSpent.year +
                            " - " +
                            abbrMonthName(
                              fiscalYearAverageTimeSpent.endMonthName
                            ) +
                            " " +
                            fiscalYearAverageTimeSpent.yearTo}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalYearAverageTimeSpent(true);
                              setOpenSearchFiscalYear(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="bar"
                  data={averageTimeSpentSummaryData}
                  options={averageTimeSpentSummaryOptions}
                  style={{ minHeight: "250px" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-4 col-md-4 col-lg-4 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Top 5 Active Users
                </Typography>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="doughnut"
                  data={topActiveUsersSummaryData}
                  options={topActiveUsersSummaryOptions}
                  plugins={[topActiveUsersSummaryPlugins]}
                  style={{ minHeight: "123px" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Last Login Overview
                </Typography>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="doughnut"
                  data={lastLoginOverviewSummaryData}
                  options={lastLoginOverviewSummaryOptions}
                  plugins={[lastLoginOverviewSummaryPlugins]}
                  style={{ minHeight: "123px" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Top 5 Visited Areas
                </Typography>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="doughnut"
                  data={topVisitedAreasSummaryData}
                  options={topVisitedAreasSummaryOptions}
                  plugins={[topVisitedAreasSummaryPlugins]}
                  style={{ minHeight: "123px" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6 col-md-6 col-lg-6 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  User Actions
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(fiscalYearUserActions.startMonthName) +
                            " " +
                            fiscalYearUserActions.year +
                            " - " +
                            abbrMonthName(fiscalYearUserActions.endMonthName) +
                            " " +
                            fiscalYearUserActions.yearTo}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalYearUserActions(true);
                              setOpenSearchFiscalYear(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="bar"
                  data={userActionsSummaryData}
                  options={userActionsSummaryOptions}
                  style={{ minHeight: "180px" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-6 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Sign In Device
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(
                            fiscalYearSignInDevice.startMonthName
                          ) +
                            " " +
                            fiscalYearSignInDevice.year +
                            " - " +
                            abbrMonthName(fiscalYearSignInDevice.endMonthName) +
                            " " +
                            fiscalYearSignInDevice.yearTo}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalYearSignInDevice(true);
                              setOpenSearchFiscalYear(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="bar"
                  data={signInDeviceSummaryData}
                  options={signInDeviceSummaryOptions}
                  style={{ minHeight: "180px" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <DialogLayout
        open={openSearchFiscalYear}
        title="Search Fiscal Year"
        onCloseDialog={() => {
          setOpenSearchFiscalYear(false);
        }}
        maxWIdth="md"
      >
        <SearchFiscalYear
          onSelectFiscalYear={(fiscalYear) => {
            if (openSearchFiscalYearActiveUser) {
              setFiscalYearActiveUser({
                ID: fiscalYear.ID,
                year: fiscalYear.year,
                yearTo: fiscalYear.yearTo,
                startMonth: fiscalYear.startMonth,
                startMonthName: fiscalYear.startMonthName,
                endMonth: fiscalYear.endMonth,
                endMonthName: fiscalYear.endMonthName,
              });
              setOpenSearchFiscalYearActiveUser(false);
              getActiveUserSummaryData(fiscalYear.ID);
            } else if (openSearchFiscalYearAverageTimeSpent) {
              setFiscalYearAverageTimeSpent({
                ID: fiscalYear.ID,
                year: fiscalYear.year,
                yearTo: fiscalYear.yearTo,
                startMonth: fiscalYear.startMonth,
                startMonthName: fiscalYear.startMonthName,
                endMonth: fiscalYear.endMonth,
                endMonthName: fiscalYear.endMonthName,
              });
              setOpenSearchFiscalYearAverageTimeSpent(false);
              getAverageTimeSpentSummaryData(fiscalYear.ID);
            } else if (openSearchFiscalYearUserActions) {
              setFiscalYearUserActions({
                ID: fiscalYear.ID,
                year: fiscalYear.year,
                yearTo: fiscalYear.yearTo,
                startMonth: fiscalYear.startMonth,
                startMonthName: fiscalYear.startMonthName,
                endMonth: fiscalYear.endMonth,
                endMonthName: fiscalYear.endMonthName,
              });
              setOpenSearchFiscalYearUserActions(false);
              getUserActionsSummaryData(fiscalYear.ID);
            } else if (openSearchFiscalYearSignInDevice) {
              setFiscalYearSignInDevice({
                ID: fiscalYear.ID,
                year: fiscalYear.year,
                yearTo: fiscalYear.yearTo,
                startMonth: fiscalYear.startMonth,
                startMonthName: fiscalYear.startMonthName,
                endMonth: fiscalYear.endMonth,
                endMonthName: fiscalYear.endMonthName,
              });
              setOpenSearchFiscalYearSignInDevice(false);
              getSignInDeviceSummaryData(fiscalYear.ID);
            }
            setOpenSearchFiscalYear(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchFiscalYear(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}

export default UserDashboard;
